var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16Z",
    fill: "url(#paint0_radial_1590_13082)",
    stroke: "url(#paint1_linear_1590_13082)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2083 18.4332C11.7592 18.4315 12.2892 18.2161 12.6928 17.8299L16.6354 20.1504C16.5033 20.6821 16.5615 21.245 16.7994 21.7361C17.0373 22.2272 17.439 22.6136 17.9309 22.8245C18.4227 23.0355 18.9719 23.057 19.4779 22.8849C19.9839 22.7129 20.4128 22.3589 20.6861 21.8878C20.9594 21.4167 21.0589 20.8599 20.9662 20.3195C20.8736 19.779 20.5951 19.291 20.1816 18.9447C19.7682 18.5985 19.2476 18.4172 18.715 18.4341C18.1824 18.4509 17.6736 18.6648 17.2816 19.0365L13.339 16.716C13.3805 16.5539 13.4032 16.3858 13.407 16.2178L17.2803 13.9376C17.6533 14.2871 18.1316 14.4938 18.635 14.5232C19.1384 14.5525 19.6363 14.4026 20.0451 14.0986C20.454 13.7947 20.7489 13.3551 20.8804 12.8538C21.0119 12.3524 20.972 11.8196 20.7674 11.345C20.5628 10.8703 20.206 10.4825 19.7567 10.2467C19.3074 10.0109 18.7931 9.94145 18.3 10.0499C17.8069 10.1584 17.3651 10.4383 17.0486 10.8426C16.732 11.2469 16.5601 11.751 16.5617 12.2703C16.5642 12.4572 16.5888 12.6434 16.6354 12.8237L13.0556 14.9301C12.848 14.5993 12.5604 14.3298 12.2211 14.1481C11.8818 13.9664 11.5024 13.8788 11.1203 13.8938C10.7381 13.9088 10.3664 14.026 10.0415 14.2338C9.71661 14.4416 9.44981 14.7328 9.26728 15.079C9.08476 15.4251 8.9928 15.8142 9.00044 16.208C9.00808 16.6019 9.11506 16.9869 9.31086 17.3252C9.50666 17.6636 9.78455 17.9436 10.1172 18.1379C10.4499 18.3322 10.8259 18.4339 11.2083 18.4332Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1590_13082",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 16) rotate(90) scale(16)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00577C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1590_13082",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46B6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947917,
    stopColor: "#238DAE",
    stopOpacity: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.17c9a1626c77bfe00e4efcfb3d101538.svg";
export { ForwardRef as ReactComponent };